import dayjs from 'dayjs';

export const matchesProductAndBenefit = (rule, { productServiceOid, isBrand, benefit }) =>
    rule.product_service_oid === productServiceOid &&
    rule.is_brand === isBrand &&
    rule.benefit === benefit;

export const matchesProductPOSBenefit = (rule, values) =>
    matchesProductAndBenefit(rule, values) &&
    (rule.place_of_service ?? null) === (values.placeOfService ?? null);

/** Closed [start, end]: still effective when end is null or asOf is on/before end. */
const isEffectiveOn = (rule, asOf = dayjs().startOf('day')) =>
    !rule.backstop_end_date || !asOf.isAfter(dayjs(rule.backstop_end_date).startOf('day'), 'day');

export const hasSegmentUniversalOverlap = (globalRules, values) =>
    Boolean(
        values.productServiceOid &&
        values.isBrand != null &&
        values.benefit &&
        globalRules?.some((rule) => isEffectiveOn(rule) && matchesProductAndBenefit(rule, values)),
    );

/** Sibling rules (segment or universal) with same product + POS + benefit. */
export const getOverlappingSegmentRules = (segmentRules, values, excludeId) => {
    if (!values.productServiceOid || values.isBrand == null || !values.benefit) {
        return [];
    }
    return (segmentRules ?? []).filter(
        (rule) =>
            rule.backstop_pharmacy_id !== excludeId &&
            isEffectiveOn(rule) &&
            matchesProductPOSBenefit(rule, values),
    );
};

/**
 * Build react-day-picker disabled matchers for other rules' active ranges.
 * Ranges are closed [start, end] like the backend; open-ended end disables from start forward.
 */
export const createDisableDateMatchers = (rules) =>
    rules.flatMap((rule) => {
        if (!rule.backstop_start_date) {
            return [];
        }
        const start = dayjs(rule.backstop_start_date).startOf('day');
        if (rule.backstop_end_date == null) {
            return [{ after: start.subtract(1, 'day').toDate() }];
        }
        const lastInclusive = dayjs(rule.backstop_end_date).startOf('day');
        if (lastInclusive.isBefore(start, 'day')) {
            return [];
        }
        return [{ from: start.toDate(), to: lastInclusive.toDate() }];
    });
